import projection from '../generated/pwm503f1.json';
import { AcceptanceManifest } from '../types';

export const pwm503f1AcceptanceManifest = projection as AcceptanceManifest;
